import {
  TAddRenewVisaDocumentCreationGroupListReqDto,
  TAddRenewVisaDocumentCreationGroupListResDto,
} from "@/api/services/main/renew-visa/dtos/add-renew-visa-document-creation-group-list.dto";
import {
  TCreateOrUpdateRenewVisaApplicationInformationDocumentReqDto,
  TCreateOrUpdateRenewVisaApplicationInformationDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-application-information-document.dto";
import {
  TCreateOrUpdateRenewVisaApplicationInformationDocumentGroupReqDto,
  TCreateOrUpdateRenewVisaApplicationInformationDocumentGroupResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-application-information-group-list.dto";
import {
  TCreateOrUpdateRenewVisaApplicationResultInformationDocumentGroupReqDto,
  TCreateOrUpdateRenewVisaApplicationResultInformationDocumentGroupResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-application-result-information-group-list.dto";

import {
  TCreateOrUpdateRenewVisaBasicInformationDocumentGroupReqDto,
  TCreateOrUpdateRenewVisaBasicInformationDocumentGroupResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-basic-information-document-group.dto";

import {
  TCreateOrUpdateRenewVisaCompanyApplicationDocumentReqDto,
  TCreateOrUpdateRenewVisaCompanyApplicationDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-company-application-document.dto";
import {
  TCreateOrUpdateRenewVisaEmployeeApplicationDocumentReqDto,
  TCreateOrUpdateRenewVisaEmployeeApplicationDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-employee-application-document.dto";
import {
  TCreateOrUpdateRenewVisaResidenceCardInformationDocumentReqDto,
  TCreateOrUpdateRenewVisaResidenceCardInformationDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-residence-card-information-document.dto";
import {
  TCreateOrUpdateRenewVisaResidenceCardInformationDocumentGroupReqDto,
  TCreateOrUpdateRenewVisaResidenceCardInformationDocumentGroupResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-residence-card-information-group-list.dto";
import {
  TCreateOrUpdateRenewVisaUploadFileDocumentReqDto,
  TCreateOrUpdateRenewVisaUploadFileDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-renew-visa-upload-file-document.dto";
import {
  TCreateOrUpdateRenewVisaUploadAvatarFileDocumentReqDto,
  TCreateOrUpdateRenewVisaUploadAvatarFileDocumentResDto,
} from "@/api/services/main/renew-visa/dtos/create-or-update-upload-avatar-file-document.dto";
import {
  TCreateRenewVisaDocumentGroupReqDto,
  TCreateRenewVisaDocumentGroupResDto,
} from "@/api/services/main/renew-visa/dtos/create-renew-visa-document-group.dto";
import {
  TDeleteRenewVisaDocumentCreationGroupListReqDto,
  TDeleteRenewVisaDocumentCreationGroupListResDto,
} from "@/api/services/main/renew-visa/dtos/delete-renew-visa-document-creation-group-list.dto";
import { TFinishRenewVisaDocumentCreationGroupResDto } from "@/api/services/main/renew-visa/dtos/finish-renew-visa-document-creation-group.dto";
import {
  TFinishSubmitDocumentStepGroupReqDto,
  TFinishSubmitDocumentStepGroupResDto,
} from "@/api/services/main/renew-visa/dtos/finish-submit-document-step-group.dto";

import { TFinishSubmitDocumentReqDto, TFinishSubmitDocumentResDto } from "@/api/services/main/renew-visa/dtos/finish-submit-document.dto";
import { TGetRenewVisaDocumentCreationGroupDownloadListResDto } from "@/api/services/main/renew-visa/dtos/get-coe-document-creation-group-download.dto";
import {
  TGetHistoryRenewVisaDocumentGroupListReqDto,
  TGetHistoryRenewVisaDocumentGroupListResDto,
} from "@/api/services/main/renew-visa/dtos/get-history-renew-visa-document-group-list.dto";

import { TGetTRenewVisaApplicationInformationDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-application-information-document.dto";
import { TGetRenewVisaApplicationInformationGroupResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-application-information-group.dto";
import { TGetRenewVisaApplicationResultInformationGroupResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-application-result-information-group.dto";
import { TGetRenewVisaBasicInformationDocumentGroupResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-basic-information-document-group.dto";
import { TGetRenewVisaBasicInformationDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-basic-information-document.dto";
import { TGetTRenewVisaCompanyApplicationDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-company-application-document.dto";
import { TGetRenewVisaDocumentCreationGroupListResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-document-creation-group-list.dto";
import { TGetRenewVisaDocumentGroupResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-document-group.dto";
import {
  TGetRenewVisaDocumentListToExportCsvReqDto,
  TGetRenewVisaDocumentListToExportCsvResDto,
} from "@/api/services/main/renew-visa/dtos/get-renew-visa-document-list-to-export-csv.dto";
import {
  TGetRenewVisaDocumentListReqDto,
  TGetRenewVisaDocumentListResDto,
} from "@/api/services/main/renew-visa/dtos/get-renew-visa-document-list.dto";

import { TGetRenewVisaDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-document.dto";
import { TGetTRenewVisaEmployeeApplicationDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-employee-application-document.dto";
import { TGetTRenewVisaResidenceCardInformationDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-residence-card-information-document.dto";
import { TGetRenewVisaResidenceCardInformationGroupResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-residence-card-information-group.dto";
import { TGetTRenewVisaUploadAvatarFileDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-upload-avatar-file-document.dto";
import { TGetTRenewVisaUploadFileDocumentResDto } from "@/api/services/main/renew-visa/dtos/get-renew-visa-upload-file-document.dto";
import { TResetRenewVisaDocumentGroupResDto } from "@/api/services/main/renew-visa/dtos/reset-renew-visa-document-group.dto";
import {
  TSkipRenewVisaDocumentStepGroupReqDto,
  TSkipRenewVisaDocumentStepGroupResDto,
} from "@/api/services/main/renew-visa/dtos/skip-renew-visa-document-step-group";

import { TUpdateDocumentGroupNoteReqDto, TUpdateDocumentGroupNoteResDto } from "@/api/services/main/renew-visa/dtos/update-document-group-note.dto";
import { TUpdateDocumentNoteReqDto, TUpdateDocumentNoteResDto } from "@/api/services/main/renew-visa/dtos/update-document-note.dto";
import { TUpdateExpectSubmitDateReqDto, TUpdateExpectSubmitDateResDto } from "@/api/services/main/renew-visa/dtos/update-expect-submit-date.dto";
import { TUpdateMergedPdfFilePathReqDto, TUpdateMergedPdfFilePathResDto } from "@/api/services/main/renew-visa/dtos/update-merged-pdf-file-path.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { usePagination } from "@/hooks/usePagination";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

//renew-visa-document-group
export const createRenewVisaDocumentGroupApi = async (payload: TCreateRenewVisaDocumentGroupReqDto): Promise<TCreateRenewVisaDocumentGroupResDto> => {
  const rs = await clientApi.post<TCreateRenewVisaDocumentGroupResDto>(`/renew-visa-document-groups`, payload);
  return rs.data;
};

export const fetchRenewVisaDocumentGroupInfoApi = async (id: string | number): Promise<TGetRenewVisaDocumentGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaDocumentGroupResDto>(`/renew-visa-document-groups/${id}`);
  return rs.data;
};

export const useGetRenewVisaDocumentGroupInfo = (id?: number | string) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const fetchId = id ?? employeeRenewVisaDocumentGroupId;

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_GROUP_DETAIL, fetchId],
    queryFn: () => (fetchId ? fetchRenewVisaDocumentGroupInfoApi(fetchId) : undefined),
    enabled: Boolean(fetchId),
  });

  return { data: data?.data, ...rest };
};

//update-document-group-note
export const updateRenewVisaDocumentGroupNoteApi = async (
  employeeRenewVisaDocumentGroupId: string | number,
  payload: TUpdateDocumentGroupNoteReqDto,
): Promise<TUpdateDocumentGroupNoteResDto> => {
  const rs = await clientApi.put<TUpdateDocumentGroupNoteResDto>(
    `/renew-visa-document-groups/${employeeRenewVisaDocumentGroupId}/update-document-note`,
    payload,
  );
  return rs.data;
};

// finish-step-3-group
export const finishSubmitDocumentStepGroupApi = async (
  payload: TFinishSubmitDocumentStepGroupReqDto,
): Promise<TFinishSubmitDocumentStepGroupResDto> => {
  const { data } = await clientApi.post<TFinishSubmitDocumentStepGroupResDto>(
    "/renew-visa-document-groups/finish-submit-document-step-group",
    payload,
  );
  return data;
};

// skip-step-one-to-three
export const skipRenewVisaDocumentStepGroupApi = async (
  payload: TSkipRenewVisaDocumentStepGroupReqDto,
): Promise<TSkipRenewVisaDocumentStepGroupResDto> => {
  const { data } = await clientApi.post<TSkipRenewVisaDocumentStepGroupResDto>("/renew-visa-document-groups/skip-step", payload);
  return data;
};

// document-creation-group

export const fetchRenewVisaDocumentCreationGroupDownloadListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaDocumentCreationGroupDownloadListResDto> => {
  const rs = await clientApi.get<TGetRenewVisaDocumentCreationGroupDownloadListResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/document-creation/get-download-list`,
  );

  return rs.data;
};

export const fetchRenewVisaDocumentCreationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaDocumentCreationGroupListResDto> => {
  const rs = await clientApi.get<TGetRenewVisaDocumentCreationGroupListResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/document-creation/list`,
  );

  return rs.data;
};

type useGetRenewVisaDocumentCreationGroupListProps = {
  renewVisaDocumentStepGroupId: string | number;
};

export const useGetRenewVisaDocumentCreationGroupList = ({ renewVisaDocumentStepGroupId }: useGetRenewVisaDocumentCreationGroupListProps) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_DOCUMENT_CREATION_GROUP, employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId && renewVisaDocumentStepGroupId
        ? fetchRenewVisaDocumentCreationGroupListApi(employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId)
        : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId && !!renewVisaDocumentStepGroupId,
  });

  return { data: data?.data, ...rest };
};

export const addRenewVisaDocumentCreationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TAddRenewVisaDocumentCreationGroupListReqDto,
): Promise<TAddRenewVisaDocumentCreationGroupListResDto> => {
  const rs = await clientApi.put<TAddRenewVisaDocumentCreationGroupListResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/document-creation/add-list`,
    payload,
  );
  return rs.data;
};

export const deleteRenewVisaDocumentCreationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TDeleteRenewVisaDocumentCreationGroupListReqDto,
): Promise<TDeleteRenewVisaDocumentCreationGroupListResDto> => {
  const rs = await clientApi.put<TDeleteRenewVisaDocumentCreationGroupListResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/document-creation/delete-list`,
    payload,
  );
  return rs.data;
};

export const finishRenewVisaDocumentCreationGroupApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TFinishRenewVisaDocumentCreationGroupResDto> => {
  const rs = await clientApi.put<TFinishRenewVisaDocumentCreationGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/document-creation/finish`,
  );
  return rs.data;
};

// application-information-group
export const createOrUpdateRenewVisaApplicationInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TCreateOrUpdateRenewVisaApplicationInformationDocumentGroupReqDto,
): Promise<TCreateOrUpdateRenewVisaApplicationInformationDocumentGroupResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaApplicationInformationDocumentGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/application-information/list`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaApplicationInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaApplicationInformationGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaApplicationInformationGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/application-information/list`,
  );

  return rs.data;
};

type useGetRenewVisaApplicationInformationGroupListProps = {
  renewVisaDocumentStepGroupId: string | number;
};

export const useGetRenewVisaApplicationInformationGroupList = ({
  renewVisaDocumentStepGroupId,
}: useGetRenewVisaApplicationInformationGroupListProps) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_APPLICATION_INFORMATION_GROUP, employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId && renewVisaDocumentStepGroupId
        ? fetchRenewVisaApplicationInformationGroupListApi(employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId)
        : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId && !!renewVisaDocumentStepGroupId,
  });

  return { data: data?.data, ...rest };
};

// application-result-information-group
export const createOrUpdateRenewVisaApplicationResultInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TCreateOrUpdateRenewVisaApplicationResultInformationDocumentGroupReqDto,
): Promise<TCreateOrUpdateRenewVisaApplicationResultInformationDocumentGroupResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaApplicationResultInformationDocumentGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/application-result-information/list`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaApplicationResultInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaApplicationResultInformationGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaApplicationResultInformationGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/application-result-information/list`,
  );

  return rs.data;
};

type useGetRenewVisaApplicationResultInformationGroupListProps = {
  renewVisaDocumentStepGroupId: string | number;
};

export const useGetRenewVisaApplicationResultInformationGroupList = ({
  renewVisaDocumentStepGroupId,
}: useGetRenewVisaApplicationResultInformationGroupListProps) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [
      QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_APPLICATION_RESULT_INFORMATION_GROUP,
      employeeRenewVisaDocumentGroupId,
      renewVisaDocumentStepGroupId,
    ],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId && renewVisaDocumentStepGroupId
        ? fetchRenewVisaApplicationResultInformationGroupListApi(employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId)
        : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId && !!renewVisaDocumentStepGroupId,
  });

  return { data: data?.data, ...rest };
};

// residence-card-info-group
export const createOrUpdateRenewVisaResidenceCardInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TCreateOrUpdateRenewVisaResidenceCardInformationDocumentGroupReqDto,
): Promise<TCreateOrUpdateRenewVisaResidenceCardInformationDocumentGroupResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaResidenceCardInformationDocumentGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/residence-card-information/list`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaResidenceCardInformationGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaResidenceCardInformationGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaResidenceCardInformationGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/residence-card-information/list`,
  );

  return rs.data;
};

type UseGetRenewVisaResidenceCardInformationGroupListProps = {
  renewVisaDocumentStepGroupId: string | number;
  enabled: boolean;
};

export const useGetRenewVisaResidenceCardInformationGroupList = ({
  renewVisaDocumentStepGroupId,
  enabled,
}: UseGetRenewVisaResidenceCardInformationGroupListProps) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [
      QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_RESIDENCE_CARD_INFORMATION_GROUP,
      employeeRenewVisaDocumentGroupId,
      renewVisaDocumentStepGroupId,
    ],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId && renewVisaDocumentStepGroupId
        ? fetchRenewVisaResidenceCardInformationGroupListApi(employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId)
        : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId && !!renewVisaDocumentStepGroupId && enabled,
  });

  return { data: data?.data, ...rest };
};

// renew-visa-document-group-history
export const fetchHistoryRenewVisaDocumentGroupListApi = async (
  renewVisaDocumentGroupId: string | number,
  request: TGetHistoryRenewVisaDocumentGroupListReqDto,
): Promise<TGetHistoryRenewVisaDocumentGroupListResDto> => {
  const url = createUrlWithParams(`/renew-visa-document-groups/${renewVisaDocumentGroupId}/history`, request);
  const { data } = await clientApi.get<TGetHistoryRenewVisaDocumentGroupListResDto>(url);
  return data;
};

export const useGetHistoryRenewVisaDocumentGroupList = () => {
  const pagReq = usePagination();

  const { employeeRenewVisaDocumentGroupId } = useParams();

  const params = { ...pagReq };

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_HISTORY_GROUP_LIST, params],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId ? fetchHistoryRenewVisaDocumentGroupListApi(employeeRenewVisaDocumentGroupId, params) : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId,
  });

  return { data, ...rest };
};

// renew-visa-document-present
export const fetchRenewVisaDocumentListApi = async (request: TGetRenewVisaDocumentListReqDto): Promise<TGetRenewVisaDocumentListResDto> => {
  const url = createUrlWithParams("/renew-visa-documents", request);
  const { data } = await clientApi.get<TGetRenewVisaDocumentListResDto>(url);
  return data;
};

type TUseGetRenewVisaDocumentListParams = TGetRenewVisaDocumentListReqDto;

export const useGetRenewVisaDocumentList = (params?: TUseGetRenewVisaDocumentListParams) => {
  const pagReq = usePagination();

  const request = params ?? {
    ...pagReq,
  };

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LIST, request],
    queryFn: () => fetchRenewVisaDocumentListApi(request),
  });

  return { data, ...rest };
};

export const fetchRenewVisaDocumentListToExportCsvApi = async (
  request: TGetRenewVisaDocumentListToExportCsvReqDto,
): Promise<TGetRenewVisaDocumentListToExportCsvResDto> => {
  const url = createUrlWithParams("/renew-visa-documents/export-csv", request);
  const { data } = await clientApi.get<TGetRenewVisaDocumentListToExportCsvResDto>(url);

  return data;
};

export const fetchRenewVisaDocumentInfoApi = async (id: string | number): Promise<TGetRenewVisaDocumentResDto> => {
  const rs = await clientApi.get<TGetRenewVisaDocumentResDto>(`/renew-visa-documents/${id}`);
  return rs.data;
};

export const useGetRenewVisaDocumentInfo = (id?: number) => {
  const { renewVisaDocumentId } = useParams();

  const fetchId = id ?? renewVisaDocumentId;

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_DETAIL, fetchId],
    queryFn: () => (fetchId ? fetchRenewVisaDocumentInfoApi(fetchId) : undefined),
    enabled: Boolean(fetchId),
  });

  return { data: data?.data, ...rest };
};

export const fetchLatestCompleteRenewVisaDocumentInfoApi = async (): Promise<TGetRenewVisaDocumentResDto> => {
  const rs = await clientApi.get<TGetRenewVisaDocumentResDto>(`/renew-visa-documents/latest-complete`);
  return rs.data;
};

export const useLatestCompleteGetRenewVisaDocumentInfo = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LATEST_DETAIL],
    queryFn: () => fetchLatestCompleteRenewVisaDocumentInfoApi(),
  });

  return { data: data, ...rest };
};

export const finishSubmitDocumentStepApi = async (payload: TFinishSubmitDocumentReqDto): Promise<TFinishSubmitDocumentResDto> => {
  const { data } = await clientApi.post<TFinishSubmitDocumentResDto>("/renew-visa-documents/finish-submit-document-step", payload);
  return data;
};

// update-expect-submit-date
export const updateExpectSubmitDateApi = async (
  id: string | number,
  payload: TUpdateExpectSubmitDateReqDto,
): Promise<TUpdateExpectSubmitDateResDto> => {
  const { data } = await clientApi.put<TUpdateExpectSubmitDateResDto>(`/renew-visa-documents/${id}/update-expect-submit-date`, payload);
  return data;
};

// basic information group
export const createOrUpdateRenewVisaBasicInformationDocumentGroupApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
  payload: TCreateOrUpdateRenewVisaBasicInformationDocumentGroupReqDto,
): Promise<TCreateOrUpdateRenewVisaBasicInformationDocumentGroupResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaBasicInformationDocumentGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/basic-information`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaBasicInformationDocumentGroupApi = async (
  renewVisaDocumentGroupId: string | number,
  renewVisaDocumentStepGroupId: string | number,
): Promise<TGetRenewVisaBasicInformationDocumentGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaBasicInformationDocumentGroupResDto>(
    `/renew-visa-document-groups/${renewVisaDocumentGroupId}/steps/${renewVisaDocumentStepGroupId}/basic-information`,
  );

  return rs.data;
};

type UseGetRenewVisaBasicInformationDocumentInfoProps = {
  renewVisaDocumentStepGroupId: string | number;
};

export const useGetRenewVisaBasicInformationDocumentGroupInfo = ({
  renewVisaDocumentStepGroupId,
}: UseGetRenewVisaBasicInformationDocumentInfoProps) => {
  const { employeeRenewVisaDocumentGroupId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_BASIC_INFORMATION_GROUP, employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId],
    queryFn: () =>
      employeeRenewVisaDocumentGroupId && renewVisaDocumentStepGroupId
        ? fetchRenewVisaBasicInformationDocumentGroupApi(employeeRenewVisaDocumentGroupId, renewVisaDocumentStepGroupId)
        : undefined,
    enabled: !!employeeRenewVisaDocumentGroupId && !!renewVisaDocumentStepGroupId,
  });

  return { data: data?.data, ...rest };
};

export const fetchRenewVisaBasicInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetRenewVisaBasicInformationDocumentGroupResDto> => {
  const rs = await clientApi.get<TGetRenewVisaBasicInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/basic-information`,
  );

  return rs.data;
};

//employee-application

export const createRenewVisaEmployeeApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaEmployeeApplicationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaEmployeeApplicationDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaEmployeeApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/employee-application`,
    payload,
  );
  return rs.data;
};

export const updateRenewVisaEmployeeApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaEmployeeApplicationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaEmployeeApplicationDocumentResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaEmployeeApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/employee-application`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaEmployeeApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaEmployeeApplicationDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaEmployeeApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/employee-application`,
  );
  return rs.data;
};

type TUseGetRenewVisaEmployeeApplicationDocumentInfoProps = {
  applicationDocumentStepId?: string | number;
};

export const useGetRenewVisaEmployeeApplicationDocumentInfo = (props?: TUseGetRenewVisaEmployeeApplicationDocumentInfoProps) => {
  const { renewVisaDocumentId, documentStepId } = useParams();

  const docStepId = props?.applicationDocumentStepId ?? documentStepId;

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_EMPLOYEE_APPLICATION, renewVisaDocumentId, docStepId],
    queryFn: () => (renewVisaDocumentId && docStepId ? fetchRenewVisaEmployeeApplicationDocumentApi(renewVisaDocumentId, docStepId) : undefined),
    enabled: !!renewVisaDocumentId && !!docStepId,
  });

  return { data: data?.data, ...rest };
};

//company-application

export const createRenewVisaCompanyApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaCompanyApplicationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaCompanyApplicationDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaCompanyApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/company-application`,
    payload,
  );
  return rs.data;
};

export const updateRenewVisaCompanyApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaCompanyApplicationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaCompanyApplicationDocumentResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaCompanyApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/company-application`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaCompanyApplicationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaCompanyApplicationDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaCompanyApplicationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/company-application`,
  );
  return rs.data;
};

type TUseGetRenewVisaCompanyApplicationDocumentInfoProps = {
  renewVisaDocumentId?: string | number;
  applicationDocumentStepId?: string | number;
};

export const useGetRenewVisaCompanyApplicationDocumentInfo = (props?: TUseGetRenewVisaCompanyApplicationDocumentInfoProps) => {
  const { renewVisaDocumentId, documentStepId } = useParams();

  const docId = props?.renewVisaDocumentId ?? renewVisaDocumentId;
  const docStepId = props?.applicationDocumentStepId ?? documentStepId;

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_COMPANY_APPLICATION, docId, docStepId],
    queryFn: () => (docId && docStepId ? fetchRenewVisaCompanyApplicationDocumentApi(docId, docStepId) : undefined),
    enabled: !!docId && !!docStepId,
  });

  return { data: data?.data, ...rest };
};

//upload-file
export const createRenewVisaUploadFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaUploadFileDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaUploadFileDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaUploadFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-file`,
    payload,
  );
  return rs.data;
};

export const updateRenewVisaUploadFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaUploadFileDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaUploadFileDocumentResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaUploadFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-file`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaUploadFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaUploadFileDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaUploadFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-file`,
  );
  return rs.data;
};

type UseGetRenewVisaUploadFileDocumentInfoProps = {
  enabled: boolean;
  documentStepId: string | number;
};

export const useGetRenewVisaUploadFileDocumentInfo = ({ enabled, documentStepId }: UseGetRenewVisaUploadFileDocumentInfoProps) => {
  const { renewVisaDocumentId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_UPLOAD_FILE, renewVisaDocumentId, documentStepId],
    queryFn: () => (renewVisaDocumentId && documentStepId ? fetchRenewVisaUploadFileDocumentApi(renewVisaDocumentId, documentStepId) : undefined),
    enabled: !!renewVisaDocumentId && !!documentStepId && enabled,
  });

  return { data: data?.data, ...rest };
};

//residence-card-information

export const createRenewVisaResidenceCardInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaResidenceCardInformationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaResidenceCardInformationDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaResidenceCardInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/residence-card-information`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaResidenceCardInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaResidenceCardInformationDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaResidenceCardInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/residence-card-information`,
  );
  return rs.data;
};

type UseGetRenewVisaResidenceCardInformationDocumentInfoProps = {
  documentStepId: string | number;
};

export const useGetRenewVisaResidenceCardInformationDocumentInfo = ({ documentStepId }: UseGetRenewVisaResidenceCardInformationDocumentInfoProps) => {
  const { renewVisaDocumentId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_RESIDENCE_CARD_INFORMATION, renewVisaDocumentId, documentStepId],
    queryFn: () =>
      renewVisaDocumentId && documentStepId ? fetchRenewVisaResidenceCardInformationDocumentApi(renewVisaDocumentId, documentStepId) : undefined,
    enabled: !!renewVisaDocumentId && !!documentStepId,
  });

  return { data: data?.data, ...rest };
};

//application-information

export const createRenewVisaApplicationInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaApplicationInformationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaApplicationInformationDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaApplicationInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/application-information`,
    payload,
  );
  return rs.data;
};

export const updateRenewVisaApplicationInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaApplicationInformationDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaApplicationInformationDocumentResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaApplicationInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/application-information`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaApplicationInformationDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaApplicationInformationDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaApplicationInformationDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/application-information`,
  );
  return rs.data;
};

type UseGetRenewVisaApplicationInformationDocumentInfoProps = {
  documentStepId: string | number;
  enabled: boolean;
};

export const useGetRenewVisaApplicationInformationDocumentInfo = ({
  documentStepId,
  enabled,
}: UseGetRenewVisaApplicationInformationDocumentInfoProps) => {
  const { renewVisaDocumentId } = useParams();

  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_APPLICATION_INFORMATION, renewVisaDocumentId, documentStepId],
    queryFn: () =>
      renewVisaDocumentId && documentStepId ? fetchRenewVisaApplicationInformationDocumentApi(renewVisaDocumentId, documentStepId) : undefined,
    enabled: !!renewVisaDocumentId && !!documentStepId && enabled,
  });

  return { data: data?.data, ...rest };
};

//upload-avatar-file

export const createRenewVisaUploadAvatarFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaUploadAvatarFileDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaUploadAvatarFileDocumentResDto> => {
  const rs = await clientApi.post<TCreateOrUpdateRenewVisaUploadAvatarFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-avatar-file`,
    payload,
  );
  return rs.data;
};

export const updateRenewVisaUploadAvatarFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
  payload: TCreateOrUpdateRenewVisaUploadAvatarFileDocumentReqDto,
): Promise<TCreateOrUpdateRenewVisaUploadAvatarFileDocumentResDto> => {
  const rs = await clientApi.put<TCreateOrUpdateRenewVisaUploadAvatarFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-avatar-file`,
    payload,
  );
  return rs.data;
};

export const fetchRenewVisaUploadAvatarFileDocumentApi = async (
  renewVisaDocumentId: string | number,
  documentStepId: string | number,
): Promise<TGetTRenewVisaUploadAvatarFileDocumentResDto> => {
  const rs = await clientApi.get<TGetTRenewVisaUploadAvatarFileDocumentResDto>(
    `/renew-visa-documents/${renewVisaDocumentId}/steps/${documentStepId}/upload-avatar-file`,
  );
  return rs.data;
};

type UseGetRenewVisaUploadAvatarFileDocumentInfoProps = {
  renewVisaDocumentId: string | number;
  documentStepId: string | number;
};

export const useGetRenewVisaUploadAvatarFileDocumentInfo = ({
  documentStepId,
  renewVisaDocumentId,
}: UseGetRenewVisaUploadAvatarFileDocumentInfoProps) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_UPLOAD_AVATAR_FILE, renewVisaDocumentId, documentStepId],
    queryFn: () =>
      renewVisaDocumentId && documentStepId ? fetchRenewVisaUploadAvatarFileDocumentApi(renewVisaDocumentId, documentStepId) : undefined,
    enabled: !!renewVisaDocumentId && !!documentStepId,
  });

  return { data: data?.data, ...rest };
};

//update-document-note
export const updateRenewVisaDocumentNoteApi = async (
  renewVisaDocumentId: string | number,
  payload: TUpdateDocumentNoteReqDto,
): Promise<TUpdateDocumentNoteResDto> => {
  const rs = await clientApi.put<TUpdateDocumentNoteResDto>(`/renew-visa-documents/${renewVisaDocumentId}/update-document-note`, payload);
  return rs.data;
};

export const updateRenewVisaDocumentMergedPdfFilePathApi = async (
  renewVisaDocumentId: string | number,
  payload: TUpdateMergedPdfFilePathReqDto,
): Promise<TUpdateMergedPdfFilePathResDto> => {
  const rs = await clientApi.put<TUpdateMergedPdfFilePathResDto>(`/renew-visa-documents/${renewVisaDocumentId}/update-merged-pdf-file-path`, payload);
  return rs.data;
};

export const resetRenewVisaDocumentGroupApi = async (renewVisaDocumentGroupId: string | number): Promise<TResetRenewVisaDocumentGroupResDto> => {
  const rs = await clientApi.put<TResetRenewVisaDocumentGroupResDto>(`/renew-visa-document-groups/${renewVisaDocumentGroupId}/reset`);
  return rs.data;
};
